<template lang="html">
  <v-app>
    <v-app-bar app flat>
      <v-spacer />
      <LocaleSwitch />
    </v-app-bar>
    <TheAppCardWrapper basic>
      <slot />
    </TheAppCardWrapper>
  </v-app>
</template>

<script>
import TheAppCardWrapper from '@/components/TheAppCardWrapper.vue';
import LocaleSwitch from '@/components/LocaleSwitch.vue';

export default {
  name: 'BasicLayout',
  components: {
    TheAppCardWrapper,
    LocaleSwitch,
  },
};
</script>

<style lang="css">
body {
  overflow: scroll !important;
  overflow-x: hidden !important;
}
</style>